var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"notification-form-group",attrs:{"invalid-feedback":_vm.message,"state":_vm.state},nativeOn:{"notification":function($event){return _vm.messageReceived($event)},"change":function($event){return _vm.clearMessage($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ad2dd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MessageFormGroup.vue
// module id = dCkL
// module chunks = 1